// LEGACY: Uses @ion/components for the underlying select. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import propTypes from 'prop-types';

import GatedConsentModeSelect from 'app/components/consent-mode-select/GatedConsentModeSelect';

import buildConsentCategoryModeSelectProps from './buildConsentCategoryModeSelectProps';

export default function ConsentCategoryModeSelect({ formState, setField, ...props }) {
  const consentCategoryModeSelectProps = buildConsentCategoryModeSelectProps({ formState, setField, ...props });

  return <GatedConsentModeSelect {...consentCategoryModeSelectProps} />;
}

ConsentCategoryModeSelect.propTypes = {
  formState: propTypes.object.isRequired,
  setField: propTypes.func.isRequired,
};
